// AUTO-GENERATED SQL Builder (V40 Final) for OfferingSlot
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class OfferingSlotSql {
  private ast = new SqlAst('OfferingSlot', 'offeringSlot');
  public readonly main: any = {};

  public guid: SqlField;
  public offeringId: SqlField;
  public serviceCategoryId: SqlField;
  public isOn: SqlField;
  public createdByUser: SqlNavHybrid;
  public offering: SqlNavHybrid;
  public serviceCategory: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public slotOptionList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('offeringSlot', 'guid', '', 'id', 'offeringSlot_guid');
    this.offeringId = new SqlField('offeringSlot', 'offeringId', 'offering', 'id', 'offeringSlot_offering');
    this.serviceCategoryId = new SqlField('offeringSlot', 'serviceCategoryId', 'serviceCategory', 'id', 'offeringSlot_serviceCategory');
    this.isOn = new SqlField('offeringSlot', 'isOn', '', 'id', 'offeringSlot_isOn');
    this.createdByUser = createNavHybrid('offeringSlot', 'offeringSlot_createdByUser', 'User');
    this.offering = createNavHybrid('offeringSlot', 'offeringSlot_offering', 'Offering');
    this.serviceCategory = createNavHybrid('offeringSlot', 'offeringSlot_serviceCategory', 'ServiceCategory');
    this.updatedByUser = createNavHybrid('offeringSlot', 'offeringSlot_updatedByUser', 'User');
    this.slotOptionList = createNavHybrid('offeringSlot', 'offeringSlot_slotOptionList', 'SlotOption');
    this.id = new SqlField('offeringSlot', 'id', '', 'id', 'offeringSlot_id');
    this.isDeleted = new SqlField('offeringSlot', 'isDeleted', '', 'id', 'offeringSlot_isDeleted');
    this.createdBy = new SqlField('offeringSlot', 'createdBy', '', 'id', 'offeringSlot_createdBy');
    this.createdDate = new SqlField('offeringSlot', 'createdDate', '', 'id', 'offeringSlot_createdDate');
    this.updatedBy = new SqlField('offeringSlot', 'updatedBy', '', 'id', 'offeringSlot_updatedBy');
    this.updatedDate = new SqlField('offeringSlot', 'updatedDate', '', 'id', 'offeringSlot_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:OfferingSlotSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:OfferingSlotSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:OfferingSlotSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:OfferingSlotSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:OfferingSlotSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:OfferingSlotSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:OfferingSlotSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:OfferingSlotSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:OfferingSlotSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:OfferingSlotSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
